import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/admin/clinicians/statistics")({
    beforeLoad: () => {
        throw redirect({ to: "/customers/clinicians", replace: true });
    },
});
